define('vspot-angular/services/coreg-service',[], function () {
    'use strict';

    return ['resources.Coreg', function (Coreg) {

        return {
            query: function() {
                return Coreg.query();
            },
            update: function(postData) {
                return Coreg.update(postData);
            }
        };
    }];
});

